import { MagentoCart } from 'lib/types'
import { CartProduct } from 'lib/core/services/gtm/types'
import { SimpleProductItem } from 'lib/core/data/quote/addProduct/types'
import { GTM } from 'lib/core/services/gtm'
import { getPriceValues } from 'lib/core/resources/helpers'
import { CartData, CartItem } from 'lib/core/data/quote/cart/types'
import { Ga4Events } from '../../../../../gtm/index'

interface TriggerSimpleAddToCartParams {
  cart: MagentoCart
  simpleProducts?: SimpleProductItem[]
  pwaCart?: CartData
}

export const triggerSimpleAddToCart = ({
  cart,
  simpleProducts,
  pwaCart
}: TriggerSimpleAddToCartParams) => {
  const addToCartProducts: CartProduct[] = []
  const currencyCode = cart.items[0]?.prices.price.currency

  simpleProducts?.forEach(item => {
    const { quantity, sku } = item
    const product = cart?.items.find(element => element.product.sku === sku)?.product
    const [amount] = product?.price ? getPriceValues(product?.price) : [0]

    addToCartProducts.push({
      id: sku,
      name: product?.name ?? '',
      price: amount.toString(),
      quantity
    })
  })

  if (addToCartProducts.length) {
    GTM.addToCart({
      currencyCode: currencyCode,
      products: addToCartProducts,
      pwaCart
    })
    Ga4Events.addToCart({
      cartItems: cart.items as unknown as CartItem[] ?? []
    })
  }
}
